import React from 'react';
import { Redirect } from 'react-router-dom';
import withScrollTo from '../../components/ScrollTo';
// 首页
import IndexPage from '../pages/Home';
import KnowledgeRetrieval from '../pages/KnowledgeRetrieval';
import PicturelistPage from '../pages/PicturelistPage';
import ImgDetail from '../pages/ImgDetail';
import Subject from '../pages/Subject';
import Question from '../pages/Question';
import Refenrences from '../pages/References';
import KnowledgeSearch from '../pages/KnowledgeSearch';
import ArchitecturalDetails from '../pages/ArchitecturalDetails';
import NoMatch from '../pages/NoMatch';
import { createBrowserHistory } from 'history';
import Relation from '../pages/Relation';
// import Star from '../common/Star';

// 个人中心
import { S_Aside } from './routes.js';
import Infor from '../pages/PersonalPage/infor';
import ChangePassword from '../pages/PersonalPage/changepassward';
// import ChangeInvoice from '../pages/PersonalPage/changeInvoice';
import Collection from '../pages/PersonalPage/collection';
import DoStar from '../pages/PersonalPage/dostar';
import Track from '../pages/PersonalPage/track';

export const history = createBrowserHistory();
export const PersonalRoutes = [
  {
    path: '/PersonalPage/Infor',
    component: withScrollTo(Infor),
    exact: true
  },
  {
    path: '/PersonalPage/ChangePassword',
    component: withScrollTo(ChangePassword),
    exact: true
  },
  {
    path: '/PersonalPage/Collection',
    component: withScrollTo(Collection),
    exact: true
  },
  {
    path: '/PersonalPage/DoStar',
    component: withScrollTo(DoStar),
    exact: true
  },
  {
    path: '/PersonalPage/Track',
    component: withScrollTo(Track),
    exact: true
  }
];

const mainRoutes = [
  {
    path: '/',
    component: withScrollTo(IndexPage),
    exact: true
  },
  // {
  //   path: '/Star',
  //   component: withScrollTo(Star),
  //   exact: true
  // },
  {
    path: '/home',
    component: withScrollTo(IndexPage),
    exact: true
  },
  {
    path: '/KnowledgeRetrieval',
    component: withScrollTo(KnowledgeRetrieval),
    exact: true
  },
  {
    path: '/PicturelistPage',
    component: withScrollTo(PicturelistPage),
    exact: true
  },
  {
    path: '/PicturelistPage/:instanceId',
    component: withScrollTo(ImgDetail),
    exact: true
  },
  {
    path: '/Subject',
    component: () => <Redirect to="/Subject/HistoricalBuilding" />,
    exact: true
  },
  {
    path: '/Subject/:sec',
    component: withScrollTo(Subject),
    exact: true
  },
  {
    path: '/Subject/:sec/:id',
    component: withScrollTo(ArchitecturalDetails),
    exact: true
  },
  {
    path: '/Question',
    component: withScrollTo(Question),
    exact: true
  },
  {
    path: '/Refenrences',
    component: withScrollTo(Refenrences),
    exact: true
  },
  {
    path: '/KnowledgeSearch',
    component: withScrollTo(KnowledgeSearch),
    exact: true
  },
  {
    path: '/Relation',
    component: withScrollTo(Relation),
    exact: true
  },
  {
    path: '/Relation/:id',
    component: withScrollTo(Relation),
    exact: true
  },
  {
    path: '/PersonalPage',
    component: () => <Redirect to="/PersonalPage/Infor" />,
    exact: true
  },
  {
    path: '/PersonalPage',
    component: S_Aside({ routes: PersonalRoutes }),
    exact: false
  },
  {
    path: '/*',
    component: NoMatch,
    exact: true
  }
];

export const pcRoutes = mainRoutes.concat();
